import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { GiHamburgerMenu } from "react-icons/gi";
// import logo from "../../assets/logojouzourounawhite.png";
import logoscrolled from "../../assets/logojouzourouna.png";
import "./Navbar.css";

const Navbar = ({ Ip }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  // Scroll to section if hash is present in URL (after navigation)
  useEffect(() => {
    if (location.pathname === "/" && location.hash) {
      const selector = location.hash;
      setTimeout(() => {
        const element = document.querySelector(selector);
        if (element) {
          const navbarHeight = 80;
          const offsetTop =
            element.getBoundingClientRect().top +
            window.pageYOffset -
            navbarHeight;

          window.scrollTo({
            top: offsetTop,
            behavior: "smooth",
          });

          setMenuOpen(false);
          setActiveSubmenu(null);
        }
      }, 200); // Wait for DOM to update
    }
  }, [location]);

  useEffect(() => {
    const handleScroll = () => {
      const carouselHeight =
        document.querySelector(".carousel-container")?.offsetHeight || 100;

      if (window.scrollY > carouselHeight - 80) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const buttons = [
    {
      title: "Home",
      sectionId: "carousel-section",
    },
    {
      title: "Activities",
      sectionId: "activities",
    },
    {
      title: "Media",
      sectionId: "media",
    },
    {
      title: "St.Charbel",
      sectionId: "stcharbel",
    },
    {
      title: "St.Joseph",
      sectionId: "stjoseph",
    },
    {
      title: "Downloads",
      sectionId: "downloads",
    },
    {
      title: "Committee",
      sectionId: "comittee",
    },
    {
      title: "Quotes",
      link:"/Quotes",
    },
  ];

  return (
    <div className={`navbarr ${scrolled ? "scrolled" : ""}`}>
      <div className="navbar-container">
        <Link to="/" className="logo">
          <img
            // src={scrolled ? logoscrolled : logo}
            src={logoscrolled}
            alt="logo"
            className="logo_img"
            loading="lazy"
          />
        </Link>

        <ul
          className={`navList ${menuOpen ? "open" : ""} ${
            scrolled ? "scrolled" : ""
          }`}
        >
          {buttons.map((item, index) => (
            <li key={index} className="navItem">
              <div
                className="navLink"
                onClick={() => {
                  {item.sectionId ? (navigate(`/#${item.sectionId}`)) : navigate(item.link)};
                  setMenuOpen(false);
                  setActiveSubmenu(null);
                }}
                style={{ cursor: "pointer" }}
              >
                {item.title}
              </div>
            </li>
          ))}
        </ul>
        <Link to="#support" className="Donate-header">Support Us</Link>
        <div className="menuIcon" onClick={() => setMenuOpen(!menuOpen)}>
          <GiHamburgerMenu size={24} color={scrolled ? "#1b2b57" : "white"} />
        </div>
      </div>

      {menuOpen && (
        <div className="navbar-overlay" onClick={() => setMenuOpen(false)} />
      )}
    </div>
  );
};

export default Navbar;
